const selectors = {
  characterCount: '[data-character-count]',
  giftInput: '[name="properties[Are you sending these as a gift?]"]',
  giftMessage: '[name="properties[Leave a gift message!]"]',
  giftMessageWrapper: '[data-gift-message-wrapper]',
  giftProductFields: '[data-gift-product-fields]',
};

const model = {
  isGift: false,
  characterCount: 0,
};

const view = {
  init(fields) {
    this.fields = fields;
    this.giftInputs = fields.querySelectorAll(selectors.giftInput);
    this.giftMessage = fields.querySelector(selectors.giftMessage);
    this.giftMessageWrapper = fields.querySelector(selectors.giftMessageWrapper);
    this.characterCount = fields.querySelector(selectors.characterCount);
  },
  render() {
    const { isGift } = model;
    const { giftMessage, giftMessageWrapper, characterCount } = this;

    if (isGift) {
      giftMessageWrapper.classList.remove('hide');
    } else {
      giftMessageWrapper.classList.add('hide');
      giftMessage.value = '';
    }

    characterCount.innerText = model.characterCount;
  },
  getSelectedGiftInput() {
    let selected;

    Array.from(this.giftInputs).forEach((input) => {
      if (input.checked) {
        selected = input;
      }
    });

    return selected;
  },
};

const giftOption = {
  init() {
    const giftProductFields = document.querySelector(selectors.giftProductFields);

    if (!giftProductFields) return;

    this.handleRadioInputChange = this.handleRadioInputChange.bind(this);
    this.handleTextAreaChange = this.handleTextAreaChange.bind(this);

    view.init(giftProductFields);
    this.verifyGiftSelection();
    view.render();
    this.addEventListeners();
  },
  addEventListeners() {
    document.addEventListener('change', this.handleRadioInputChange);
    document.addEventListener('keyup', this.handleTextAreaChange);
  },
  handleRadioInputChange(event) {
    const target = event.target.closest(selectors.giftInput);

    if (!target) return;

    const { value } = target;
    this.updateModelBasedOnValue(value);
    view.render();
  },
  handleTextAreaChange(event) {
    const target = event.target.closest(selectors.giftMessage);

    if (!target) return;

    const { value } = target;
    const characters = value.split('');
    if (model.characterCount !== characters.length) {
      model.characterCount = characters.length;
      view.render();
    }
  },
  verifyGiftSelection() {
    const selected = view.getSelectedGiftInput();

    if (!selected) return;

    const { value } = selected;
    this.updateModelBasedOnValue(value);
  },
  updateModelBasedOnValue(value) {
    if (value === 'Yes') {
      model.isGift = true;
    } else {
      model.isGift = false;
    }
  },
};

export default giftOption;
